import React from "react";

import RoundedArrowButton from "../RoundedArrowButton";


const Headline = () => {
  return (
    <section className="py-12 md:px-[75px] px-6 bg-gradient-to-b from-[#FFFFFF] to-[#FFEDA9]">
      <div className=" text-left border-b pb-4 border-[#2C3075] ">
        {/* Heading */}
        <p
          className="font-garamond-subheading font-normal text-[#2C3075] mb-8"
          style={{
            fontSize: "32px",
            lineHeight: "110%",
          }}
        >
          <span className="font-garamond-subheading hidden md:inline" style={{ fontSize: "64px", lineHeight: "100%" }}>
            With empathy and expertise, we guide individuals to overcome challenges and embrace a healthier, more fulfilling life.
          </span>
          <span className="font-garamond-subheading md:hidden">
            With empathy and expertise, we guide individuals to overcome challenges and embrace a healthier, more fulfilling life.
          </span>
        </p>

        {/* Button */}
        <div className=" py-6 ">
              <RoundedArrowButton label="See all service we provided" to="/services" />
            </div>
      </div>
    </section>
  );
};

export default Headline;
